import { IResourceRecord } from '~/client/src/shared/resources/definitions/types'

/**
 * Wraps a record predicate so already-selected resources stay visible even when
 * they fail the rule — the picker's keep-selected responsibility. Pure; call
 * sites memoize against their own selection.
 */
export function withKeepSelected(
  recordPredicate: (record: IResourceRecord) => boolean,
  keepSelectedIds: Iterable<string>,
): (record: IResourceRecord) => boolean {
  const keep = new Set(keepSelectedIds)
  return record => keep.has(record.id) || recordPredicate(record)
}
